import React, { FC, useState } from "react";
import { useHistory } from "react-router";
import { Link } from "react-router-dom";
import { Input } from "@xapp/components";
import style from "./style.scss";

export interface MatchConfidenceProps {
    gtConfidence?: number;
    ltConfidence?: number;
    paginationUrl?: string;
}

export const MatchConfidenceHeaderView: FC<MatchConfidenceProps> = ({
    gtConfidence,
    ltConfidence,
    paginationUrl
}: MatchConfidenceProps) => {

    const minGt = gtConfidence?.toString();

    const maxLt = ltConfidence?.toString();

    const [minMax, setMinMax] = useState({ min: minGt || "", max: maxLt || "" });

    const history = useHistory();

    const { min, max } = minMax;
    const newParameters = `&gtConfidence=${min}&ltConfidence=${max}`;

    const matchConfidenceClick = () => {
        if (min > max) {
            return;
        }
    };

    return (
        <div style={{ display: "flex", flexDirection: "column" }}>
            <>filter by between</>
            <br />
            <div style={{ display: "flex", alignItems: "center" }}>
                <Input
                    className={style.inputwidth}
                    label="Min"
                    name="min"
                    value={minMax.min}
                    // pattern="[0-9.]{1,2}"
                    // maxLength={3}
                    inputProps={{
                        pattern: "[0-9.]{1,2}",
                        maxLength: 3
                    }}
                    onChange={(value) =>
                        setMinMax({ ...minMax, min: value as string })
                    }
                />
                <span
                    style={{
                        fontWeight: "bold",
                        fontSize: "15px",
                    }}
                >
                    -
                </span>
                <Input
                    className={style.inputwidth}
                    label="Max"
                    name="max"
                    value={minMax.max}
                    // pattern="[0-9.]{1,2}"
                    // maxLength={3}
                    inputProps={{
                        pattern: "[0-9.]{1,2}",
                        maxLength: 3
                    }}
                    onChange={(value) =>
                        setMinMax({ ...minMax, max: value as string })
                    }
                />
                {min > max && max && (
                    <p style={{ color: "red" }}>min should be less than max</p>
                )}

                {min <= max && (
                    <Link
                        to={`${history.location.pathname}${paginationUrl}${newParameters}`}
                    >
                        <button
                            className={style.buttonGo}
                            onClick={matchConfidenceClick}
                        >
                            Go
                        </button>
                    </Link>
                )}
            </div>
        </div>
    )
}